export default __webpack_public_path__ + "img/check-bold.3dd21458.svg";